module.exports = "https://cdn.realtymogul.com/static/media/carousel-arrow-large-right.7586ae23.svg";